module.exports = __webpack_public_path__ + "img/d.31811705.png";